import { useEffect, useState } from 'react';
import { Editor } from '@tiptap/react';

interface MenuBarState {
  canBold: boolean;
  canItalic: boolean;
  canBulletList: boolean;
  canOrderedList: boolean;
}

const DEFAULT_STATE: MenuBarState = {
  canBold: false,
  canItalic: false,
  canBulletList: false,
  canOrderedList: false,
};

export const useMenuBarState = (editor: Editor | null): MenuBarState => {
  const [state, setState] = useState<MenuBarState>(DEFAULT_STATE);

  useEffect(() => {
    if (!editor) {
      setState(DEFAULT_STATE);
      return;
    }

    const updateState = () => {
      setState({
        canBold: editor.can().toggleBold(),
        canItalic: editor.can().toggleItalic(),
        canBulletList: editor.can().toggleBulletList(),
        canOrderedList: editor.can().toggleOrderedList(),
      });
    };

    editor.on('update', updateState);
    updateState();

    return () => {
      editor.off('update', updateState);
    };
  }, [editor]);

  return state;
};

export default useMenuBarState;
